import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
    selector: 'app-cost-center-list',
    templateUrl: './../../../templates/forms/modals/voucher-type.component.html',
})
export class VoucherTypeListComponent implements OnInit {



    @Input()
    modalShow: boolean = true;


    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;
    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "VoucherTypeListGrid"
    voucherTypeList = [];



    searchFields: any[] = ['TYPE_NAME', 'VTYPE_NO'];
    public searchString;
    constructor(private dataService: CommonService,
        public langService: LangService,
        public gridService: GridService) {
        this.colObj = [
            { headerName: langService.langData.typeNameCap, field: 'TYPE_NAME', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.aliasCap, field: 'ALIAS', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.vTypeNo, field: 'VTYPE_NO', sortable: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);
        this.dataService.getVoucherTypes(fixedValues.queryOptions.VoucherTypeForTDB)
            .subscribe(arg => { console.log(arg); this.voucherTypeList = arg.body });
    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}


